export const inputClasses =
  'w-full border-0 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-indigo-600 dark:text-white sm:leading-6'
export const buttonDisabledClasses =
  'bg-indigo-300 focus-visible:outline-indigo-300 cursor-not-allowed'
export const buttonEnabledClasses =
  'bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600'
export const buttonClasses =
  'inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-center text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-base'
